import axios from "axios";
import { configEnv } from "../constant";

export type SearchEntityType =
    | "audits"
    | "assessments"
    | "evaluations"
    | "anecdotals"
    | "tasks"
    | "imageVerification"
    | "people"
    | "groups"
    | "parameters"
    | "criteria"
    | "auditCategories"
    | "organizations"
    | "templates"
    | "departments"
    | "posts"
    | "tickets"
    | "notices"
    | "questionBanks"
    | "students"
    | "oneTimeAudits";

export type SearchReferenceKey =
    | "auditsAsAuditor"
    | "auditsAsAuditee"
    | "tasksAssigned"
    | "tasksCreated"
    | "imageVerifications"
    | "groups"
    | "anecdotalsAsObserver"
    | "anecdotalsAsAuditee"
    | "assessmentsInvited"
    | "assessmentsCreated"
    | "evaluationsAssigned"
    | "evaluationsCreated"
    | "postsCreated"
    | "postsCommented"
    | "postsLiked"
    | "ticketsRaised"
    | "ticketsCommented"
    | "audits"
    | "auditForms"
    | "tasks"
    | "assessments"
    | "evaluations"
    | "anecdotals"
    | "auditCategories"
    | "parameters"
    | "criteria";

export interface SearchRelatedItem {
    _id: string;
    title: string;
    subtitle?: string;
    url: string;
    openTaskId?: string;
}

export interface SearchReference {
    key: SearchReferenceKey;
    total: number;
    items: SearchRelatedItem[];
    listUrl?: string;
}

export interface SearchResultItem {
    _id: string;
    title: string;
    subtitle?: string;
    url: string;
    updatedAt?: string;
    openTaskId?: string;
    references?: SearchReference[];
}

export type UnifiedSearchResults = Record<SearchEntityType, SearchResultItem[]>;
export type UnifiedSearchTotals = Record<SearchEntityType, number>;

export interface UnifiedSearchResponse {
    q: string;
    organizationId: string;
    results: UnifiedSearchResults;
    totals: UnifiedSearchTotals;
}

export const searchApi = {
    unifiedSearch: async (
        params: {
            q: string;
            organizationId: string;
            types?: SearchEntityType[];
            limit?: number;
        },
        header: any,
        signal?: AbortSignal
    ): Promise<UnifiedSearchResponse | null> => {
        try {
            const qs = new URLSearchParams();
            qs.set("q", params.q);
            qs.set("organizationId", params.organizationId);
            if (params.limit) qs.set("limit", String(params.limit));
            if (params.types && params.types.length > 0) {
                qs.set("types", params.types.join(","));
            }

            const response = await axios({
                method: "GET",
                url: `${configEnv.baseUrl}/search?${qs.toString()}`,
                headers: header || { "Content-Type": "application/json" },
                signal,
            });
            return response.data?.data || null;
        } catch (error: any) {
            if (axios.isCancel(error) || error?.name === "CanceledError") {
                return null;
            }
            console.error("search api error", error);
            throw error;
        }
    },
};
